module.exports = __webpack_public_path__ + "static/specialists-slideshow-04@2x-de3f6f6a76bde1cca2cb0bfc6cd3681e.jpg";